import React, { useState, useRef, useCallback } from 'react';
import { DropdownButton } from 'react-bootstrap';

const UMOGridDropDownSideMenu = ({ title, menuOptions, icon }) => {
  const [show, setShow] = useState(false);
  const timerRef = useRef(null);
  const handleMouseLeave = useCallback(() => {
    const timer = setTimeout(() => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      setShow(false);
    }, 350);
    timerRef.current = timer;
  }, []);

  return (
    <DropdownButton
      title={
        <span className="umo-grid-item__overlay-dropdown-title-container">
          {title}
          <i className="pagination__next-icon" />
        </span>
      }
      variant="default"
      className="umo-grid-item__overlay-more-side-menu-btn"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setShow((preShow) => !preShow);
      }}
      drop="end"
      show={show}
      onMouseLeave={handleMouseLeave}
      onMouseEnter={() => {
        clearTimeout(timerRef.current);
      }}
    >
      {icon && icon} {menuOptions}
    </DropdownButton>
  );
};

export default UMOGridDropDownSideMenu;
